import { useState } from 'react';
import { Form, Input, Button, Select, Switch, Space, Divider, Typography, message } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { api } from '../api';

const { Text } = Typography;

const DAYS = [
  { value: 'mo', label: 'Mo' },
  { value: 'tu', label: 'Di' },
  { value: 'we', label: 'Mi' },
  { value: 'th', label: 'Do' },
  { value: 'fr', label: 'Fr' },
  { value: 'sa', label: 'Sa' },
  { value: 'su', label: 'So' },
];

export default function OpeningHoursForm({ openingHours, onSaved }) {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  const initialValues = {
    name: openingHours.name,
    slots: Array.isArray(openingHours.open_json)
      ? openingHours.open_json
      : (typeof openingHours.open_json === 'string'
          ? JSON.parse(openingHours.open_json)
          : []),
  };

  const handleSave = async (values) => {
    setSaving(true);
    try {
      await api.openingHours.update(openingHours.id, {
        name: values.name,
        open_json: values.slots || [],
      });
      message.success('Öffnungszeiten gespeichert');
      onSaved?.();
    } catch (err) {
      message.error(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={initialValues}
      onFinish={handleSave}
    >
      <Form.Item name="name" label="Bezeichnung" rules={[{ required: true }]}>
        <Input />
      </Form.Item>

      <Text type="secondary" style={{ fontSize: 12 }}>
        Jede Zeile definiert einen Zeitraum. Mehrere Einträge werden kombiniert.
      </Text>
      <Divider style={{ margin: '8px 0 12px' }} />

      <Form.List name="slots">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name }) => (
              <Form.Item noStyle key={key}>
                <SlotRow name={name} remove={() => remove(name)} />
              </Form.Item>
            ))}
            <Button
              type="dashed"
              icon={<PlusOutlined />}
              onClick={() => add({ fromDay: 'mo', toDay: 'su', openingHour: '12:00', closingHour: '22:00', closed: false })}
              style={{ width: '100%', marginTop: 8 }}
            >
              Zeitraum hinzufügen
            </Button>
          </>
        )}
      </Form.List>

      <Form.Item style={{ marginTop: 24, marginBottom: 0 }}>
        <Button type="primary" htmlType="submit" loading={saving}>
          Speichern
        </Button>
      </Form.Item>
    </Form>
  );
}

function SlotRow({ name, remove }) {
  return (
    <div style={{ background: '#fdf6ec', border: '1px solid #e8d5b0', borderRadius: 6,
                  padding: '12px 16px', marginBottom: 8 }}>
      <Space wrap style={{ width: '100%' }}>
        <Form.Item name={[name, 'fromDay']} label="Von" style={{ marginBottom: 0 }}>
          <Select options={DAYS} style={{ width: 80 }} />
        </Form.Item>
        <Form.Item name={[name, 'toDay']} label="Bis" style={{ marginBottom: 0 }}>
          <Select options={DAYS} style={{ width: 80 }} />
        </Form.Item>
        <Form.Item name={[name, 'openingHour']} label="Öffnung" style={{ marginBottom: 0 }}>
          <Input placeholder="12:00" style={{ width: 90 }} />
        </Form.Item>
        <Form.Item name={[name, 'closingHour']} label="Schließung" style={{ marginBottom: 0 }}>
          <Input placeholder="22:00" style={{ width: 90 }} />
        </Form.Item>
        <Form.Item name={[name, 'closed']} label="Geschlossen" valuePropName="checked" style={{ marginBottom: 0 }}>
          <Switch />
        </Form.Item>
        <Button
          danger
          icon={<DeleteOutlined />}
          onClick={remove}
          style={{ marginTop: 22 }}
        />
      </Space>
    </div>
  );
}
